import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}
// 分页获取设备消费规则
export function getMachine (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmacrule/page',
		method: 'post',
		data: obj
	})
}
// 新增设备消费规则
export function addMachine (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmacrule/add',
		method: 'post',
		data: obj
	})
}
// 修改设备消费规则
export function editMachine (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmacrule/edit',
		method: 'post',
		data: obj
	})
}
// 删除设备消费规则
export function delMachine (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mktmacrule/remove/${data.ruleId}`,
		method: 'post',
		data: obj
	})
}
// 删除就餐规则
export function delEatingRules (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktdiningeffective/delete',
		method: 'delete',
		data: obj
	})
}
// 获取全部充值赠送方式
export function getType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktrechargerule/selectDonateTypeEnum',
		method: 'get',
		params: obj
	})
}
// 分页获取退餐规则
export function getCancelRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmealbackrule/page',
		method: 'get',
		params: obj
	})
}
// 修改退餐规则
export function editCancelRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmealbackrule/edit',
		method: 'put',
		data: obj
	})
}
// 删除退餐规则
export function delCancelRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mktmealbackrule/remove/${data.ruleId}`,
		method: 'delete',
		data: obj
	})
}
// 新增退餐规则
export function addCancelRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktmealbackrule/add',
		method: 'post',
		data: obj
	})
}
// 创建红包
export function addHongbao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktredenvelop/add', // 假地址 自行替换
		method: 'post',
		data: obj
	})
}
// 分页获取红包信息
export function getHongbao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktredenvelop/page', // 假地址 自行替换
		method: 'get',
		params: obj
	})
}
// 分页获取指定红包的领取记录列表
export function getHongbaoList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktredenvelop/record/list/page', // 假地址 自行替换
		method: 'get',
		params: obj
	})
}
// 修改红包信息
export function editHongbao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktredenvelop/edit', // 假地址 自行替换
		method: 'put',
		data: obj
	})
}
// 手动发放红包
export function faHongbao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mktredenvelop/grant/${data.envelopId}`, // 假地址 自行替换
		method: 'post',
		data: obj
	})
}
// 获取支付方式
export function getPayType (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/pay/all/type', // 假地址 自行替换
		method: 'get',
		params: obj
	})
}
// 新增时段定额
export function addInterval (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkttimequota/add', // 假地址 自行替换
		method: 'post',
		data: obj
	})
}
// 获取时段定额
export function getInterval (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkttimequota/page', // 假地址 自行替换
		method: 'get',
		params: obj
	})
}
// 修改时段定额
export function editInterval (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkttimequota/edit', // 假地址 自行替换
		method: 'put',
		data: obj
	})
}
// 删除时段定额
export function delInterval (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mkttimequota/remove/${data.quotaId}`, // 假地址 自行替换
		method: 'delete',
		data: obj
	})
}
// 新增充值规则信息
export function addChongzhiRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktrechargerule/add', // 假地址 自行替换
		method: 'post',
		data: obj
	})
}
// 获取充值规则信息
export function getChongzhiRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktrechargerule/page', // 假地址 自行替换
		method: 'get',
		params: obj
	})
}
// 修改充值规则信息
export function editChongzhiRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktrechargerule/edit', // 假地址 自行替换
		method: 'put',
		data: obj
	})
}
// 删除充值规则信息
export function delChongzhiRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mktrechargerule/remove/${data.ruleId}`, // 假地址 自行替换
		method: 'delete',
		data: obj
	})
}
// app餐券列表分页
export function appcanquanLog (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/coupon/app/list',
		method: 'post',
		data: obj
	})
}
// 删除红包记录
export function delHongbao (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktredenvelop/delete',
		method: 'delete',
		data: obj
	})
}
// 新增电子餐券模板
export function addElecTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/add-tmpl',
		method: 'post',
		data: obj
	})
}
// 修改电子餐券模板
export function editElecTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/modify-tmpl',
		method: 'post',
		data: obj
	})
}
// 查询电子餐券模板
export function getElecTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/list-tmpl',
		method: 'post',
		data: obj
	})
}
// 查询电子餐券模板--定时
export function getElecTempName (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/list-tmpl-name',
		method: 'post',
		data: obj
	})
}
// 新增电子餐券
export function makeElecTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/add-make',
		method: 'post',
		data: obj
	})
}
// 电子餐券制作发放 批量导入
export function exportElecTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/add-make-excel',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 新增电子餐券 定时发放模板
export function addElecTimeTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/add-fixed-tmpl',
		method: 'post',
		data: obj
	})
}
// 修改电子餐券 定时发放模板
export function editElecTimeTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/modify-fixed-tmpl',
		method: 'post',
		data: obj
	})
}
// 分页查询电子餐券定时模板
export function getElecTimeTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/page-fixed-tmpl',
		method: 'post',
		data: obj
	})
}
// 修改电子餐券 定时发放模板 状态
export function editElecTimeTempState (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/electron/modify-fixed-tmpl-state',
		method: 'post',
		data: obj
	})
}
// 分页查询电子餐券
export function getElecTempPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/page-electron',
		method: 'post',
		data: obj
	})
}
// 电子餐券延期
export function delayTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/delay',
		method: 'post',
		data: obj
	})
}
// 电子餐券作废
export function nullifyTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/nullify',
		method: 'post',
		data: obj
	})
}
// 电子餐券核销
export function writeTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/write-off',
		method: 'post',
		data: obj
	})
}
// 新增纸质餐券模板
export function addPaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/add-tmpl',
		method: 'post',
		data: obj
	})
}
// 修改纸质餐券模板
export function editPaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/modify-tmpl',
		method: 'post',
		data: obj
	})
}
// 查询纸质餐券模板
export function getPaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/list-tmpl',
		method: 'post',
		data: obj
	})
}
// 查询纸质餐券模板名称列表
export function getPaperTempList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/list-tmpl-name',
		method: 'post',
		data: obj
	})
}
// 新增纸质餐券制作
export function makePaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/add-make',
		method: 'post',
		data: obj
	})
}
// 分页查询纸质餐券制作
export function getPaperTempPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/page-make',
		method: 'post',
		data: obj
	})
}
// 新增纸质餐券领取
export function receivePaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/add-grant',
		method: 'post',
		data: obj
	})
}
// 分页查询纸质餐券领取
export function getReceivePaperTempPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/page-grant',
		method: 'post',
		data: obj
	})
}
// 分页查询纸质餐券
export function getPaperCoupPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/page-paper',
		method: 'post',
		data: obj
	})
}
// 纸质餐券导出
export function exportPaperTemp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/paper/batch-print',
		method: 'post',
		data: obj
	})
}
// 就餐规则开关
export function changeEatingRule (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mktdiningeffective/edit-active',
		method: 'post',
		data: obj
	})
}
// 就餐规则开关
export function getCouponSum (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/mkt/coupon/make/page/sum',
		method: 'post',
		data: obj
	})
}
